import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";

export const store = configureStore({ reducer: rootReducer, devTools: true });

if (typeof document !== 'undefined' && document.documentElement) {
  const onIconFontReady = () => document.documentElement.classList.add('fonts-loaded');
  if (document.fonts?.ready) {
    document.fonts.ready.then(onIconFontReady);
    setTimeout(onIconFontReady, 0);
    setTimeout(onIconFontReady, 2000);
  } else {
    onIconFontReady();
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();